import { render, staticRenderFns } from "./LargeFooter.vue?vue&type=template&id=714935b0&scoped=true&"
var script = {}
import style0 from "./LargeFooter.vue?vue&type=style&index=0&id=714935b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714935b0",
  null
  
)

export default component.exports